import { TextField } from "@mui/material";
import styled from "styled-components"

export interface IStyledTextboxLabel {
  error: boolean;
  bold: boolean;
  fontSize: 'small' | 'medium';
};

export const StyledTextboxLabel = styled.div<IStyledTextboxLabel>`
${({ theme, error, bold, fontSize }) => `
  display: flex;
  font-size: ${fontSize === 'small' ? `${theme.uptimeFontSizes.desktop.fz4}px` : `${theme.uptimeFontSizes.desktop.fz5}px`};
  font-weight: ${bold ? 'bold' : 'normal'};
  line-height: ${theme.uptimeLineHeights.desktop.lh4}px !important;
  align-items: center;
  margin-bottom: ${theme.uptimeSpace[4]}px;
  color: ${theme.uptimeColors.textColors.primary};

  .tooltip-container {
    display: flex;
    align-items: center;

    .MuiSvgIcon-fontSizeSmall {
      height: 0.8em;
      width:0.8em;
      font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
      margin-left: ${theme.uptimeSpace[5]}px;
    }
  }

`}`


export const StyledTextboxErrorMessage  = styled.div`
${({ theme}) =>`
  color: #f44336;
  font-size: 12px;
  margin: 0;
  padding-top: ${theme.uptimeSpace[5]}px;
`}`

const getDisabledBackgroundStyles = (theme: any) => `
  background-color: ${theme.uptimeColors.grayScales.grayishBackground};
  fieldset {
    border-color: #0000003b !important;
  }
`;

export const StyledTextbox = styled(TextField)<{ disabledBackground?: boolean }>`
${({theme, disabledBackground}) =>`
  width: 100%;
  margin-top: ${theme.uptimeSpace[2]}px;
  &.empty-manager fieldset {
    border-color: #f44336 !important;
  }
  .MuiInputBase-root {
    font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`}!important;
    width: 100%;
    font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
    &.Mui-disabled {
      ${disabledBackground ? getDisabledBackgroundStyles(theme) : ''}
    }
    .MuiOutlinedInput-input {
      height: 40px;
      padding: ${theme.uptimeSpace[0]} ${theme.uptimeSpace[8]}px ${theme.uptimeSpace[0]} ${theme.uptimeSpace[12]}px;
    }
    &.Mui-focused fieldset {
      border-color: ${theme.uptimeColors.mainTheme.secondary};
    }
    & fieldset {
      display: block;
      position: absolute;
      font-family: ${theme.fonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
    }
    textarea.MuiOutlinedInput-input {
      padding-right: ${theme.uptimeSpace[1]}px;
      padding-left: ${theme.uptimeSpace[5]}px;
    }
  }

`}`;

export const StyledAsterisk = styled.span(({ theme }) => `
  color: ${theme.uptimeColors.generalColors.state.danger.light};
  margin-left: ${theme.uptimeSpace[2]}px;
  font-weight: bold;
`);

export const StyledHelperText = styled.span(({ theme }) => `
  margin-left: ${theme.uptimeSpace[2]}px;
  font-size: 12px;
  color: ${theme.uptimeColors.generalColors.state.danger.light};
  font-weight: 600;
`);
